import { IKeyValueString, IQuarter } from "../models/reportModels";
import {
  columnSalaryFund,
  columnStatistical,
  columnSalaryFundTotal,
  columnLaborContract
} from "./columns";
import { columnBaoHiemXaHoi, columnKhenThuongKyLuat } from "./columns/columnProposalReport";
import { columnSalaryRaiseTab1, columnSalaryRaiseTab2, columnSalaryRaiseTab3, columnSalaryRaiseTab4 } from "./columns/columnSalaryRaise";
export const itemListAdditional = {
  name: "Tất cả báo cáo",
  id: null
};

export const REPORT_TYPE = {
  TANG_GIAM_CAN_BO: "1",
  LAO_DONG_THEO_CHUC_DANH: "2",
  BAO_HIEM: "3",
  DANH_GIA_KET_QUA_PHAN_LOAI_CAN_BO: "4",
  CHAT_LUONG_CAN_BO: "5",
  CAN_BO_NGHI_HUU_DUNG_QUY_DINH: "6",
  DANH_SACH_LAO_DONG: "7",
  THONG_KE: "8",
  DANH_SACH_DANG_VIEN: "9",
  NHAN_VIEN_THEO_PHONG_BAN: "10",
  DANH_SACH_VIEN_CHUC: "11",
  THONG_KE_HOP_DONG: "12",
  LUAN_CHUYEN_DIEU_DONG_HANG: "13",
  QUY_LUONG: "14",
  THEO_LOAI_HOP_DONG_LAO_DONG: "15",
  NANG_LUONG: "19",
  DE_XUAT: "20",
};

export const REPORT_MAPING_COLUMNS = [
  {
    type: REPORT_TYPE.TANG_GIAM_CAN_BO,
    columns: []
  },
  {
    type: REPORT_TYPE.LAO_DONG_THEO_CHUC_DANH,
    // Tạm ẩn do BE chưa làm
    // columns: columnWorkingByPosition
    columns: []
  },
  {
    type: REPORT_TYPE.BAO_HIEM,
    columns: []
  },
  {
    type: REPORT_TYPE.DANH_GIA_KET_QUA_PHAN_LOAI_CAN_BO,
    columns: []
  },
  {
    type: REPORT_TYPE.CHAT_LUONG_CAN_BO,
    // Tạm ẩn do BE chưa làm
    // columns: columnStaffQuality
    columns: []
  },
  {
    type: REPORT_TYPE.CAN_BO_NGHI_HUU_DUNG_QUY_DINH,
    columns: []
  },
  {
    type: REPORT_TYPE.DANH_SACH_LAO_DONG,
    columns: []
  },
  {
    type: REPORT_TYPE.THONG_KE,
    columns: columnStatistical
  },
  {
    type: REPORT_TYPE.DANH_SACH_DANG_VIEN,
    columns: []
  },
  {
    type: REPORT_TYPE.NHAN_VIEN_THEO_PHONG_BAN,
    columns: []
  },
  {
    type: REPORT_TYPE.DANH_SACH_VIEN_CHUC,
    columns: []
  },
  {
    type: REPORT_TYPE.THONG_KE_HOP_DONG,
    columns: columnLaborContract
  },
  {
    type: REPORT_TYPE.LUAN_CHUYEN_DIEU_DONG_HANG,
    columns: []
  },
  {
    type: REPORT_TYPE.QUY_LUONG,
    columns: columnSalaryFund,
    columnsTotal: columnSalaryFundTotal
  },
];

export const  REPORT_NANG_LUONG_COLUMNS = [
  {
    tab: 1,
    shortName: "Thường xuyên",
    name1: "DANH SÁCH CÁN BỘ, VIÊN CHỨC VÀ",
    name2: "LAO ĐỘNG HỢP ĐỒNG NÂNG BẬC LƯƠNG THƯỜNG XUYÊN NĂM",
    columns: columnSalaryRaiseTab1
  },
  {
    tab: 2,
    shortName: "TT hạn",
    name1: "DANH SÁCH CÁN BỘ, VIÊN CHỨC",
    name2: "ĐỀ NGHỊ NÂNG BẬC LƯƠNG TRƯỚC THỜI HẠN ĐÊ NGHỈ HƯU VÀ LẬP THÀNH TÍCH XUẤT SẮC NĂM",
    columns: columnSalaryRaiseTab2
  },
  {
    tab: 3,
    shortName: "KÉO DÀI NBL",
    name1: "DANH SÁCH  VIÊN CHỨC VÀ LAO ĐỘNG HỢP ĐỒNG",
    name2: "ĐỀ NGHỊ KÉO DÀI THỜI GIAN NÂNG BẬC LƯƠNG NĂM",
    columns: columnSalaryRaiseTab3
  },
  {
    tab: 4,
    shortName: "PC TNVK",
    name1: "DANH SÁCH VIÊN CHỨC, LAO ĐỘNG HỢP ĐỒNG",
    name2: "ĐỀ NGHỊ NÂNG PHỤ CẤP THÂM NIÊN VƯỢT KHUNG NĂM",
    columns: columnSalaryRaiseTab4
  },
];

export const  REPORT_DE_XUAT_COLUMNS = [
  {
    tab: 1,
    shortName: "Báo hiểm xã hội",
    name: "THÔNG TIN QUÁ TRÌNH THAM GIA BẢO HIỂM XÃ HỘI",
    columns: columnBaoHiemXaHoi
  },
  {
    tab: 2,
    shortName: "Khen thưởng, kỷ luật",
    name: "THÔNG TIN QUÁ TRÌNH KHEN THƯỞNG, KỶ LUẬT",
    columns: columnKhenThuongKyLuat
  }
];

export const REPORT_TYPE_SINGLE = [
  REPORT_TYPE.THONG_KE,
  REPORT_TYPE.LAO_DONG_THEO_CHUC_DANH,
  REPORT_TYPE.THONG_KE_HOP_DONG
];

export const REPORT_TYPE_COLLAPSE = [REPORT_TYPE.QUY_LUONG];

export const REPORT_KEY: IKeyValueString = {
  congChucVienChuc: "Cán bộ, viên chức",
  hopDong111: "Hợp đồng theo Nghị định 111/2022"
};

export const QUARTER_LIST: IQuarter[] = [
  {
    code: 1,
    name: "Quý 1",
    startDate: "-01-01",
    endDate: "-03-31"
  },
  {
    code: 2,
    name: "Quý 2",
    startDate: "-04-01",
    endDate: "-06-30"
  },
  {
    code: 3,
    name: "Quý 3",
    startDate: "-07-01",
    endDate: "-09-30"
  },
  {
    code: 4,
    name: "Quý 4",
    startDate: "-10-01",
    endDate: "-12-31"
  }
];
